import { SxProps, Theme } from '@mui/material';

const classes = {
  container: {
    paddingLeft: '23px',
    paddingRight: '23px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    mb: '16px',
  },
  hourlyRate: {
    '& fieldset': { border: 'none' },
    '& label': {
      flex: 2,
      marginBottom: 3,
    },
    '& .MuiTextField-root': {
      flex: 1,
    },
  },
  notes: {
    mb: 10,
  },
  label: {
    fontSize: 16,
    color: 'grey.800',
    mb: '16px',
  },
  rateValue: {
    fontSize: 16,
    color: 'grey.800',
    fontWeight: '600',
  },
  calculationContainer: {
    mb: '24px',
  },
  divider: {
    mb: '16px',
  },
  weekContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
